import React, { useEffect, useRef, useState } from "react";
import { array, bool, func, object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";
import assetify from "@quintype/framework/assetify";

import NavbarSearch from "../NavbarSearch";
import Navbar from "../Navbar";
import Icon from "../../../icons";
import { Facebook, Twitter, Email } from "../../../atoms/icons/StoryPageIcons";
import WatsAppIcon from "../../../atoms/icons/WatsAppIcon";
import DefaultMobileLogo from "../../../../../assets/images/palo-bangla.svg";
import MessengerIcon from "../../../../../assets/images/messenger.svg";
import LauncherIcon from "../../../../../assets/images/launcher.svg";
import VersionList from "../../../atoms/VersionList";
import { staticTexts } from "../../../utils/Translate";
import Youtube from "../../../layouts/footer/DefaultFooter/Youtube";
import Instagram from "../../../layouts/footer/KishoraloFooter/Instagram";
import { CloseIcon } from "../../../basic/icons/close-icon";

import "./verticalMenubar.m.css";

const VerticalMenubar = ({
  isVerticalMenubar,
  isDesktop,
  toggleVerticalMenubar,
  hamburgerMenu,
  domainSlug = "",
  socialLinks,
  isMobileFilter,
  publisherAttributes,
  customSocialLinks,
}) => {
  const [isMobile, setIsMobile] = useState(false);

  const verticalMenubarClassName = isVerticalMenubar ? "vertical-menubar slide-in" : "vertical-menubar";
  const socialShareLinks = customSocialLinks[domainSlug] || socialLinks;
  const ref = useRef(null);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      toggleVerticalMenubar();
    }
  };

  useEffect(() => {
    ref.current.classList.remove("preload");

    !isMobileFilter && document.addEventListener("click", handleClickOutside, true);
    return () => {
      !isMobileFilter && document.removeEventListener("click", handleClickOutside, true);
    };
  });

  useEffect(() => {
    global.deviceWidth < 876 && setIsMobile(true);
  }, []);

  const getMultiDomainStyleName = () => {
    if (domainSlug === "nagorik-sangbad") {
      return "nagorik-vertical-menubar-wrapper";
    } else if (domainSlug === "trust") {
      return "trust-menubar-wrapper";
    } else return "";
  };

  const commonMultiDomainName =
    domainSlug === "biggan-chinta" || domainSlug === "kishoralo" || domainSlug === "bigganchinta" ? "multi-domain" : "";
  const fixedWrapperName = isDesktop ? `fixed-wrapper` : "";

  const wrapperStyleName = `vertical-menubar-wrapper ${fixedWrapperName} ${commonMultiDomainName} ${getMultiDomainStyleName()}`;

  return (
    <div styleName={wrapperStyleName} className="vertical-menubar-wrapper">
      <div
        ref={ref}
        className="vertical-menubar preload"
        styleName={`${verticalMenubarClassName} ${domainSlug && domainSlug === "protichinta" ? "protichinta-ham" : ""}`}
      >
        <div
          styleName={`close ${domainSlug === "nagorik-sangbad" ? "nagorik-close" : ""} ${
            publisherAttributes.lang
          }-close`}
          onClick={toggleVerticalMenubar}
        >
          {domainSlug === "nagorik-sangbad" ? (
            !isMobile ? (
              <CloseIcon color="#ffffff" width="30" height="30" />
            ) : (
              <Icon type="close" className="close" />
            )
          ) : (
            <Icon type="close" className="close" />
          )}
        </div>
        {!isDesktop && isVerticalMenubar && <NavbarSearch publisherAttributes={publisherAttributes} />}
        <Navbar
          menu={hamburgerMenu}
          isVerticalMenubar={true}
          toggleVerticalMenubar={toggleVerticalMenubar}
          domainSlug={domainSlug}
          lang={publisherAttributes.lang}
        />
        <div styleName="bottom-container">
          {(domainSlug === "northamerica" || !domainSlug) && (
            <ul
              styleName={`version-list-wrapper ${publisherAttributes.lang === "en" ? "en-version-list-wrapper" : ""}`}
            >
              <p styleName={`version-text ${publisherAttributes.lang === "en" ? "en-version-text" : ""}`}>
                {staticTexts(publisherAttributes.lang).edition}
              </p>
              <VersionList />
            </ul>
          )}
          {domainSlug && (
            <div
              styleName={`prothomalo-logo ${
                domainSlug === "biggan-chinta" || domainSlug === "bigganchinta" || domainSlug === "kishoralo"
                  ? "no-logo"
                  : ""
              }`}
            >
              <img src={`${assetify(DefaultMobileLogo)}`} styleName="palo-logo" />
            </div>
          )}
          <div
            styleName={` social-share-icons ${
              domainSlug &&
              (domainSlug === "biggan-chinta" || domainSlug === "bigganchinta" || domainSlug === "kishoralo")
                ? "no-logo-icons"
                : ""
            }`}
          >
            {socialShareLinks["facebook-url"] && (
              <Link href={socialShareLinks["facebook-url"]} target="_blank" rel="noopener noreferrer">
                <Facebook />
              </Link>
            )}
            {socialShareLinks["twitter-url"] && (
              <Link href={socialShareLinks["twitter-url"]} target="_blank" rel="noopener noreferrer">
                <Twitter />
              </Link>
            )}
            {socialShareLinks["messenger-url"] && (
              <Link href={socialShareLinks["messenger-url"]} target="_blank" rel="noopener noreferrer">
                <img src={`${assetify(MessengerIcon)}`} styleName="messenger" />
              </Link>
            )}
            {socialShareLinks["telegram-url"] && (
              <Link href={socialShareLinks["telegram-url"]} target="_blank" rel="noopener noreferrer">
                <img src={`${assetify(LauncherIcon)}`} styleName="launcher" />
              </Link>
            )}
            {socialShareLinks["whatsapp-url"] && (
              <Link href={socialShareLinks["whatsapp-url"]} target="_blank" rel="noopener noreferrer">
                <WatsAppIcon />
              </Link>
            )}
            {socialShareLinks["email-url"] && (
              <Link href={socialShareLinks["email-url"]} target="_blank" rel="noopener noreferrer">
                <Email />
              </Link>
            )}
            {socialShareLinks["youtube-url"] && (
              <Link
                href={socialShareLinks["youtube-url"]}
                className="youtube-icon"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Youtube />
              </Link>
            )}
            {socialShareLinks["instagram-url"] && (
              <Link href={socialShareLinks["instagram-url"]} target="_blank" rel="noopener noreferrer">
                <Instagram color1="#eee" color2="#121212" />
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

VerticalMenubar.propTypes = {
  isVerticalMenubar: bool,
  isDesktop: bool,
  toggleVerticalMenubar: func,
  hamburgerMenu: array,
  domainSlug: string,
  publisherAttributes: object,
  socialLinks: object,
  isMobileFilter: bool,
  customSocialLinks: object,
};

const mapStateToProps = (state) => ({
  socialLinks: get(state, ["qt", "config", "social-links"], {}),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  isMobileFilter: get(state, ["filterReducer", "isMobileFilter"], false),
  customSocialLinks: get(state, ["qt", "config", "custom-social-links"], {}),
});

export default connect(mapStateToProps, null)(VerticalMenubar);
